import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import usersReducer from './slices/usersSlice';
import tournamentsReducer from './slices/tournamentsSlice';
import roomsReducer from './slices/roomsSlice';
import depositsReducer from './slices/depositsSlice';
import withdrawalsReducer from './slices/withdrawalsSlice';
import dashboardReducer from './slices/dashboardSlice';
import winningPatternsReducer from './slices/winningPatternsSlice';
import settingsReducer from './slices/settingsSlice';
import transactionsReducer from './slices/transactionsSlice';
import paymentMethodsReducer from './slices/paymentMethodsSlice';
import adminsReducer from './slices/adminsSlice';
import mediaReducer from './slices/mediaSlice';
import agentRequestsReducer from './slices/agentRequestsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    tournaments: tournamentsReducer,
    rooms: roomsReducer,
    deposits: depositsReducer,
    withdrawals: withdrawalsReducer,
    dashboard: dashboardReducer,
    winningPatterns: winningPatternsReducer,
    settings: settingsReducer,
    transactions: transactionsReducer,
    paymentMethods: paymentMethodsReducer,
    admins: adminsReducer,
    media: mediaReducer,
    agentRequests: agentRequestsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 